import { useState } from 'react';

export const useFormValidation = (formConfig) => {
  const [errors, setErrors] = useState({});

  const validateForm = (formData) => {
    const newErrors = {};
    
    if (!formConfig || !formConfig.inputs) return true;
    
    formConfig.inputs.forEach(input => {
      const value = formData[input.name];
      
      // Validação de campo obrigatório
      if (input.required && (!value || value.trim() === '')) {
        newErrors[input.name] = `${input.label} é obrigatório`;
      }
      
      // Validação específica de email
      if (input.type === 'email' && value && value.trim() !== '') {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value)) {
          newErrors[input.name] = 'Email inválido';
        }
      }
      
      // Validação de telefone (básica)
      if (input.type === 'phone' && value && value.trim() !== '') {
        const phoneRegex = /^[\d\s\-\+\(\)]+$/;
        if (!phoneRegex.test(value) || value.replace(/\D/g, '').length < 10) {
          newErrors[input.name] = 'Telefone inválido';
        }
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors(prev => ({
        ...prev,
        [fieldName]: ''
      }));
    }
  };

  const clearAllErrors = () => {
    setErrors({});
  };

  return {
    errors,
    validateForm,
    clearError,
    clearAllErrors
  };
};